import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { glossarTerms } from "@/utils/glossarData";

interface RelatedTermsProps {
  relatedSlugs: string[];
}

export const RelatedTerms = ({ relatedSlugs }: RelatedTermsProps) => {
  const relatedTerms = relatedSlugs
    .map(slug => glossarTerms.find(t => t.slug === slug))
    .filter(Boolean);

  if (relatedTerms.length === 0) return null;

  return (
    <Card className="mt-8 border-primary/20 bg-gradient-to-br from-primary/5 to-transparent">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <BookOpen className="h-5 w-5 text-primary" />
          Verwandte Begriffe
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3">
          {relatedTerms.map((term) => (
            <Link
              key={term!.slug}
              to={`/glossar/${term!.slug}`}
              className="group flex items-center justify-between p-3 rounded-lg border border-border hover:border-primary/50 hover:bg-accent/50 transition-all duration-200"
            >
              <div>
                <div className="font-semibold text-sm group-hover:text-primary transition-colors">
                  {term!.name}
                </div>
                <div className="text-xs text-muted-foreground mt-1 line-clamp-1">
                  {term!.shortDef}
                </div>
              </div>
              <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0" />
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
